import { render } from "./results-board-pending-user.vue?vue&type=template&id=69b9bdd5&scoped=true&ts=true"
import script from "./results-board-pending-user.vue?vue&type=script&lang=ts"
export * from "./results-board-pending-user.vue?vue&type=script&lang=ts"

import "./results-board-pending-user.vue?vue&type=style&index=0&id=69b9bdd5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b9bdd5"]])

export default __exports__